module.exports = __webpack_public_path__ + "staticVue/img/login-ag-logo.2bff2203.png";